import _axios from 'axios';
import { userManager } from '../App';

export const getAccessToken = async () => {
  try {
    const user = await userManager.getUser();
    return user ? user.id_token : null;
  } catch (error) {
    console.error('Error fetching access token:', error);
    return null;
  }
};

class MulesoftDataService {
  constructor () {
    this.axios = _axios;
    this.api = this.axios.create({
      baseURL: process.env.REACT_APP_MULESOFT_API_ENDPOINT
    })

    // Request interceptor
    this.api.interceptors.request.use(
      async (config) => {
        const access_token = await getAccessToken();
        //       adyen = config.url === `transcripts/digitalPayments` || 
        //               config.url === `transcripts/validateDigitalPayments`;
        // if(adyen){
        //   config.headers['client_id'] = process.env.REACT_APP_ADYEN_CLIENT_ID;
        //   config.headers['client_secret'] = process.env.REACT_APP_ADYEN_CLIENT_SECRET;
        // }else{
        //   config.headers['client_id'] = process.env.REACT_APP_MULESOFT_API_CLIENT_ID;
        //   config.headers['client_secret'] = process.env.REACT_APP_MULESOFT_API_CLIENT_SECRET;
        // }
        if (access_token) {
          config.headers['Authorization'] = `Bearer ${access_token}`
        }
        return config
      },
      error => {
        return Promise.reject(error)
      }
    )

    // Response interceptor
    this.api.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (error.response) {
          if(error.response.config.url === `transcripts/digitalPayments`){
              return error.response;
          }else if (error.response.status === 401) {
            localStorage.clear();
            window.location.href = '/';
          }
        }
        return Promise.reject(error);
      }
    )
  }

  async submitInfo(submitInfoData) {
    const response = await this.api({
      url: `/transcripts`,
      method: 'post',
      data: JSON.stringify(submitInfoData),
      headers: {
        'Content-Type': 'application/json',
        'X-TRANSACTION-ID': submitInfoData.transactionId
      }
    });
    return response;
  }
  
  async savePersonalInfo(personalInfoData) {
    const response = await this.api({
      url: `/candidates`,
      method: 'post',
      data: JSON.stringify(personalInfoData),
      headers: {
        'Content-Type': 'application/json',
        'X-TRANSACTION-ID': personalInfoData.transactionId
      }
    });
    return response;
  }

  async saveExamDetails(dataPayload) {
    const response = await this.api({
      url: `/qualifications`,
      method: 'post',
      data: JSON.stringify(dataPayload),
      headers: {
        'Content-Type': 'application/json',
        'X-TRANSACTION-ID': dataPayload.transactionId
      }
    });
    return response;
  }

  async saveInstitutionDetails(dataPayload) {
    const response = await this.api({
      url: `/institutions`,
      method: 'post',
      data: JSON.stringify(dataPayload),
      headers: {
        'Content-Type': 'application/json',
        'X-TRANSACTION-ID': dataPayload.transactionId
      }
    });
    return response;
  }

  async getTranscriptsCost(transactionId){
    const response = await this.api({
      url: `transcripts/costs?countryCode=US`,
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'X-TRANSACTION-ID': transactionId
      }
    });
    return response;
  }

  async getTranscriptHistory(payload){
    const response = await this.api({
      url: `candidates/${payload.uid}/orders`,
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'X-TRANSACTION-ID': payload.tId
      }
    });
    return response.data;
  }

  async getOrderSummary(payload){
    const response = await this.api({
      url: `transcripts/orderSummary?applicationReferenceNumber=${payload.appRefNum}`,
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'X-TRANSACTION-ID': payload.tId
      }
    });
    return response.data;
  }  
  async acceptedTerms(payload){
    const response = await this.api({
      url: `candidates/${payload.tReq.appRefNum}/terms`,
      method: 'post',
      data: JSON.stringify(payload.tReq.req),
      headers: {
        'Content-Type': 'application/json',
        'X-TRANSACTION-ID': payload.tReq.req.tId
      }
    });
    return response;
  }
  async getTermsAndConditions(tId){    
    const response = await this.api({
      url: `terms`,
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'X-TRANSACTION-ID': tId
      }
    });
    return response.data;
  }
  async getCreditandRecognition(institueId, transactionId){
    const response = await this.api({
      url: `creditPolicy/${institueId}`,
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'X-TRANSACTION-ID': transactionId
      }
    });
    return response.data;
  }
  async validatePaymentDue(data){
    const _payload = data.payload
    const _data = {paymentDueDate: _payload.data.paymentDueDate, applicationReferenceNumber: _payload.data.applicationReferenceNumber}
    const response = await this.api({
      url: `transcripts/validatePaymentDue`,
      method: 'post',
      data: JSON.stringify(_data),
      headers: {
        'Content-Type': 'application/json',
        'X-TRANSACTION-ID': _payload.data.transactionId
      }
    });
    return response;
  }
  async submitCardDetails(payload){
    const response = await this.api({
      url:`transcripts/digitalPayments`,
      method:'post',
      data: JSON.stringify(payload),
      headers:{
        'Content-Type': 'application/json',
        'X-TRANSACTION-ID': payload.reference
      }
    });
    return response;
  }
  async finalPayRequestAfterThreeDAuth(payload,transactionId){
    const response = await this.api({
      url:`transcripts/validateDigitalPayments`,
      method:'post',
      data: JSON.stringify(payload),
      headers:{
        'Content-Type': 'application/json',
        'X-TRANSACTION-ID': transactionId
      }
    });
    return response;
  }
  async fetchIPaddress(){
    return await this.axios.get(`https://ipinfo.io/json`);
  }
}

const instance = new MulesoftDataService();
  Object.freeze(instance);
  
export default instance;
